import times from './times';

export default function nextTime(list: Date[] = times()) {
  return function _nextTimeDetector(date: Date = new Date()) {
    const [first] = list.filter((d) => d.getTime() > date.getTime());
    if (first) {
      return first;
    }
    const [f] = list;
    return f;
  };
}
